import React, { memo } from 'react';
import PropTypes from 'prop-types';

function BrandRadarBreadcrumb({ trail, onNavigate }) {
  return (
    <nav className="BrandRadar-breadcrumb" aria-label="브랜드 탐색 경로">
      {trail.map((name, i) => (
        <React.Fragment key={name}>
          {i > 0 && <span className="BrandRadar-breadcrumb-sep">→</span>}
          <button
            type="button"
            className={`BrandRadar-breadcrumb-item ${
              i === trail.length - 1 ? 'is-current' : ''
            }`}
            onClick={() => onNavigate(name, i)}
          >
            {name}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
}

BrandRadarBreadcrumb.propTypes = {
  trail: PropTypes.arrayOf(PropTypes.string).isRequired,
  onNavigate: PropTypes.func.isRequired,
};

export default memo(BrandRadarBreadcrumb);
